<template>
  <div class="zIndex-top">
    <b-modal
      :id="`modal-${id}`"
      class="close-modal zIndex-top"
      no-close-on-backdrop
      hide-header
    >
      <h4 class="title my-2">{{ title }}</h4>
      <div v-if="icon" class="icon-container">
        <img :src="icon" alt="" class="icon-container__icon" @error="error" />
      </div>
      <div class="desc">
        <div class="d-flex">
          <img class="modal-img mr-2" src="@/assets/img/bx_info-circle.svg" />
          <div>
            <span>
              {{ description }}
            </span>
            <span v-if="extraWarning" class="error">
              {{ extraWarning }}
            </span>
          </div>
        </div>
      </div>
      <template #modal-header>
        <button />
      </template>
      <template #modal-footer>
        <div class="action-btns text-center">
          <button class="footer-btn" @click="cancelClicked">
            {{ cancel }}
          </button>
          <button class="footer-btn" @click="dismissClickHandle">
            {{ dismiss }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { USER_TRACK_EVENTS } from "../store/modules/user/consts";
import { teardownBootstrapModals } from "@/utils/modalCleanup";

export default {
  props: {
    title: String,
    description: String,
    cancel: String,
    dismiss: String,
    showModal: Boolean || true,
    id: String,
    icon: String,
    extraWarning: String,
    error: Function,
  },
  watch: {
    showModal: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.$bvModal.show(`modal-${this.id}`);
          });
        } else {
          this.$bvModal.hide(`modal-${this.id}`);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.showModal) {
      this.$nextTick(() => {
        this.$bvModal.show(`modal-${this.id}`);
      });
    }
  },
  beforeUnmount() {
    this.$bvModal.hide(`modal-${this.id}`);
    teardownBootstrapModals(`modal-${this.id}`);
  },
  methods: {
    goToPayment() {
      if (this.extraData === "1") {
        this.$DbStorage.setItem("rocketfuel_connect_bank", 1);
      }
    },
    dismissClickHandle() {
      this.$bvModal.hide(`modal-${this.id}`);
      this.$emit("dismissClicked");
      this.addEvent(
        this.title,
        "Payment Tab page",
        `shopper cliked ${this.dismiss} button`
      );
    },
    cancelClicked() {
      this.$bvModal.hide(`modal-${this.id}`);
      this.$emit("cancelClicked", true);
      this.addEvent(
        this.title,
        "Payment Tab page",
        `shopper cliked ${this.cancel} button`
      );
    },
    async addEvent(current, next, activity) {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current,
          next,
          activity,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: 600;
  font-size: 14px;
  padding: 5px 15px;
}

.desc {
  background: rgba(0, 0, 0, 0.05);
  padding: 10px;
  font-size: 13px;
  margin: 10px;
}

.footer-btn {
  padding: 0px 10px;
  cursor: pointer;
  border-radius: 5px;
  margin: 0px 5px;
  border: 1px solid #5559fe;
}

.footer-btn:nth-child(2) {
  background: #5559fe;
  color: white;
}

::v-deep(.modal-header) {
  border: none !important;
  padding: 0px 5px;
  display: none;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  &__icon {
    width: 60px;
    height: 60px;
  }
}
.zIndex-top {
  z-index: 999999 !important;
}
</style>
